/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */
// gatsby-browser.js

import clarity from "@microsoft/clarity";

export const onClientEntry = () => {
  clarity.init("tmdn5fbjat");
};


export const onRouteUpdate = () => {
    if (typeof window === "undefined") return;

    const handleClick = (event) => {
        const link = event.target.closest("a");

        if (link && link.id && window.gtag) {
            window.gtag("event", "cta_clicked", {
                event_category: "engagement",
                event_label: link.id || 'CTA', 
            });
        }
    };

    // Remove any existing listener to avoid duplicates
    document.removeEventListener("click", handleClick);
    document.addEventListener("click", handleClick);
};
